export default __webpack_public_path__ + "static/media/bg.87f653ab.png";